import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { Config } from '../config/env.config';
import { contentHeaders } from 'common/headers';
import { SearchService } from '../search/search.service';
import { SearchModel } from '../search/search.model';
import { BILLING } from '../search/search-service-types';

import { billingStubData } from './billing-stub-data';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class BillingService extends SearchService  {

  // extendable fields:
  searchModel: SearchModel = new SearchModel();
  serviceType = BILLING;
  idField = 'id';

  private rootUrl: string = 'billing';

  getSearchURI(brandId: string, searchModel: SearchModel): string {
    let res = `/subscription/${brandId}/invoices`;
    res = `${res}?page=${searchModel.currentPage}&itemsPerPage=${searchModel.itemsPerPage}`;
    return res;
  }

  runSearch(brandId: string, searchModel: SearchModel): Observable<any> {
     return this.http.get(`${Config.API}${this.getSearchURI(brandId, searchModel)}`)

       .pipe(map( (res) => {
         this.updateData(res);
         return res;
       }),
       catchError(this.handleError.bind(this)));
  }

  downloadInvoice(brandId: string, invoiceId: string): Observable<any> {
    const url = `${Config.API}/subscription/${brandId}/invoices/${invoiceId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/pdf'
    });

    return this.http.get(url, { headers: headers, responseType: 'blob' });
  }
}
